import jwtDecode from "jwt-decode";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import {
  getModuleList,
  getUserByToken,
  getUserByTokenForProfile,
} from "./authCrud";
import * as auth from "./authRedux";
import { publicRoute } from "../../../../data/publicRoute";
import { apsisDecrypt } from "../../../helpers/apsisEncryption";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const { authToken, auth } = useSelector(
    ({ auth }) => ({
      authToken: auth.authToken,
      auth: auth.coreModuleInfo,
    }),
    shallowEqual
  );

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const isPublicRoute = publicRoute.includes(
      window.location.pathname.split("/")[1]
    );
    const encryptData = window.location.href.split("en=")[1];
    const decryptToken = encryptData
      ? JSON.parse(apsisDecrypt(encryptData))
      : null;
    const params = new URLSearchParams(window.location.search);
    const token = params.get("user");
    const user =
      authToken && authToken.access_token
        ? jwtDecode(authToken.access_token)
        : null;
    const requestUser = async () => {
      try {
        if (user && Object.keys(user).length > 0) {
          // const { data } = await getUserByToken();
          const profile = await getUserByTokenForProfile();
          if (profile?.data?.success) {
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem(
              "user-profile",
              JSON.stringify(profile?.data?.data?.token_info)
            );
            dispatch(props.fulfillUser(user));
            dispatch(props.fulfillUserProfile(profile?.data?.data?.token_info));
            // localStorage.setItem("lang", data?.data?.language);
            const coreModuleToken =
              localStorage.getItem("CORE_MODULE_AUTH") &&
              localStorage.getItem("CORE_MODULE_AUTH");
            if (coreModuleToken) {
              const coreModuleInfo = profile?.data?.data?.token_info;
              coreModuleInfo.token = coreModuleToken;
              await dispatch(props.coreModuleLogin(coreModuleInfo));
            }
          }
        }
      } catch (error) {
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };
    if ((authToken && Object.keys(authToken).length > 0) || token) {
      requestUser();
      // localStorage.setItem("AUTH", JSON.stringify(authToken));
      setShowSplashScreen(false);
      return;
    } else if (isPublicRoute && decryptToken) {
      localStorage.setItem("CORE_MODULE_AUTH", decryptToken.token);
      localStorage.setItem("JOB_ID", decryptToken.job_id);
      window.location.href = window.location.pathname;
      setShowSplashScreen(false);
      return;
    } else {
      dispatch(props.fulfillUser(undefined));
      dispatch(props.fulfillUserProfile(undefined));
      setShowSplashScreen(false);

      if (!isPublicRoute) {
        setTimeout(() => {
          window.location.href = `${process.env.REACT_APP_ERP_FE}`;
        }, 2000);
      }
    }
    // eslint-disable-next-line
  }, [authToken]);

  // useLayoutEffect(() => {

  // }, [coreModuleToken]);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
